export const PAGE_SIZE_OPTIONS = [10, 20, 50]

export const customerStatusOptions = [
  { value: 'ACTIVE', label: '启用' },
  { value: 'DISABLED', label: '停用' }
]

export const idTypeOptions = [
  { value: 'ID_CARD', label: '身份证' },
  { value: 'PASSPORT', label: '护照' },
  { value: 'OTHER', label: '其他' }
]

export const genderOptions = [
  { value: 'MALE', label: '男' },
  { value: 'FEMALE', label: '女' },
  { value: 'UNKNOWN', label: '未知' }
]

export const riskLevelOptions = [
  { value: 'LOW', label: '低风险' },
  { value: 'MEDIUM', label: '中风险' },
  { value: 'HIGH', label: '高风险' }
]

export const contractStatusOptions = [
  { value: 'PENDING_APPROVAL', label: '待审批' },
  { value: 'ACTIVE', label: '有效' },
  { value: 'CLOSED', label: '已关闭' },
  { value: 'WITHDRAWN', label: '已撤资' }
]

export const batchStatusOptions = [
  { value: 'ACTIVE', label: '有效' },
  { value: 'UPCOMING_MATURITY', label: '即将到期' },
  { value: 'MATURED', label: '已到期未处理' },
  { value: 'REDUCED_TO_ZERO', label: '已减至零' },
  { value: 'WITHDRAWN', label: '已撤资' },
  { value: 'ROLLED_OVER', label: '已续期' }
]

export const applyStatusOptions = [
  { value: 'SUBMITTING', label: '提交中' },
  { value: 'APPROVAL_START_FAILED', label: '发起失败' },
  { value: 'APPROVING', label: '审批中' },
  { value: 'REJECTED', label: '已驳回' },
  { value: 'CANCELLED', label: '已撤回' },
  { value: 'ACCOUNTED', label: '已落账' },
  { value: 'ACCOUNT_FAILED', label: '落账失败' }
]

export const operationTypeOptions = [
  { value: 'INVEST', label: '注资' },
  { value: 'INCREASE', label: '增资' },
  { value: 'DECREASE', label: '减资' },
  { value: 'WITHDRAW', label: '撤资' },
  { value: 'ROLLOVER', label: '续期' }
]

export const directionOptions = [
  { value: 'IN', label: '流入' },
  { value: 'OUT', label: '流出' },
  { value: 'NONE', label: '不变' }
]

const badgeMaps = {
  customer: {
    ACTIVE: { label: '启用', class: 'bg-emerald-100 text-emerald-700' },
    DISABLED: { label: '停用', class: 'bg-slate-100 text-slate-600' }
  },
  contract: {
    PENDING_APPROVAL: { label: '待审批', class: 'bg-amber-100 text-amber-700' },
    ACTIVE: { label: '有效', class: 'bg-emerald-100 text-emerald-700' },
    CLOSED: { label: '已关闭', class: 'bg-slate-100 text-slate-600' },
    WITHDRAWN: { label: '已撤资', class: 'bg-red-100 text-red-700' }
  },
  batch: {
    ACTIVE: { label: '有效', class: 'bg-emerald-100 text-emerald-700' },
    UPCOMING_MATURITY: { label: '即将到期', class: 'bg-orange-100 text-orange-700' },
    MATURED: { label: '已到期未处理', class: 'bg-amber-100 text-amber-700' },
    REDUCED_TO_ZERO: { label: '已减至零', class: 'bg-slate-100 text-slate-600' },
    WITHDRAWN: { label: '已撤资', class: 'bg-red-100 text-red-700' },
    ROLLED_OVER: { label: '已续期', class: 'bg-indigo-100 text-indigo-700' }
  },
  apply: {
    SUBMITTING: { label: '提交中', class: 'bg-blue-100 text-blue-700' },
    APPROVAL_START_FAILED: { label: '发起失败', class: 'bg-red-100 text-red-700' },
    APPROVING: { label: '审批中', class: 'bg-amber-100 text-amber-700' },
    REJECTED: { label: '已驳回', class: 'bg-slate-100 text-slate-600' },
    CANCELLED: { label: '已撤回', class: 'bg-slate-100 text-slate-600' },
    ACCOUNTED: { label: '已落账', class: 'bg-emerald-100 text-emerald-700' },
    ACCOUNT_FAILED: { label: '落账失败', class: 'bg-red-100 text-red-700' }
  },
  operation: {
    INVEST: { label: '注资', class: 'bg-emerald-100 text-emerald-700' },
    INCREASE: { label: '增资', class: 'bg-blue-100 text-blue-700' },
    DECREASE: { label: '减资', class: 'bg-amber-100 text-amber-700' },
    WITHDRAW: { label: '撤资', class: 'bg-red-100 text-red-700' },
    ROLLOVER: { label: '续期', class: 'bg-indigo-100 text-indigo-700' }
  },
  risk: {
    LOW: { label: '低风险', class: 'bg-emerald-100 text-emerald-700' },
    MEDIUM: { label: '中风险', class: 'bg-amber-100 text-amber-700' },
    HIGH: { label: '高风险', class: 'bg-red-100 text-red-700' }
  },
  direction: {
    IN: { label: '流入', class: 'bg-emerald-100 text-emerald-700' },
    OUT: { label: '流出', class: 'bg-red-100 text-red-700' },
    NONE: { label: '不变', class: 'bg-slate-100 text-slate-600' }
  },
  permission: {
    ACTIVE: { label: '启用', class: 'bg-emerald-100 text-emerald-700' },
    DISABLED: { label: '停用', class: 'bg-slate-100 text-slate-600' }
  },
  scope: {
    SELF: { label: '本人', class: 'bg-slate-100 text-slate-600' },
    DEPT: { label: '部门', class: 'bg-blue-100 text-blue-700' },
    TENANT: { label: '全租户', class: 'bg-indigo-100 text-indigo-700' }
  }
}

export function getBadgeMeta(type, value) {
  const key = value === null || value === undefined ? '' : String(value)
  return badgeMaps[type]?.[key] || { label: key || '--', class: 'bg-slate-100 text-slate-600' }
}

export function findOptionLabel(options, value) {
  return options.find(item => item.value === value)?.label || value || '--'
}

export function toNumber(value) {
  if (value === null || value === undefined || value === '') return 0
  const number = Number(value)
  return Number.isFinite(number) ? number : 0
}

export function formatMoney(value) {
  if (value === null || value === undefined || value === '') return '--'
  return toNumber(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatRate(value) {
  if (value === null || value === undefined || value === '') return '--'
  return `${toNumber(value).toLocaleString('zh-CN', { maximumFractionDigits: 4 })}%`
}

export function formatDate(value) {
  if (!value) return '--'
  return String(value).slice(0, 10)
}

export function formatDateTime(value) {
  if (!value) return '--'
  return String(value).replace('T', ' ').slice(0, 19)
}

export function maskPhone(value) {
  if (!value) return '--'
  const text = String(value)
  if (text.length < 7) return text
  return `${text.slice(0, 3)}****${text.slice(-4)}`
}

export function maskIdNo(value) {
  if (!value) return '--'
  const text = String(value)
  if (text.length <= 8) return text
  return `${text.slice(0, 4)}********${text.slice(-4)}`
}

export function parseAssetIds(value) {
  if (!value) return []
  return String(value)
    .split(/[\s,，;；]+/)
    .map(item => Number(item.trim()))
    .filter(item => Number.isFinite(item) && item > 0)
}

export function cleanPayload(payload) {
  const result = {}
  Object.keys(payload || {}).forEach(key => {
    const value = payload[key]
    if (value === '' || value === undefined || value === null) return
    result[key] = value
  })
  return result
}

export function pagePayload(pagination, extra = {}) {
  return cleanPayload({
    ...extra,
    page: pagination.current || pagination.page || 1,
    size: pagination.size || 10
  })
}

export function syncPageResult(pagination, result = {}) {
  pagination.current = Number(result.current || result.page || pagination.current || 1)
  pagination.page = pagination.current
  pagination.size = Number(result.size || result.pageSize || pagination.size || 10)
  pagination.total = Number(result.total || 0)
  pagination.pages = Number(result.pages || result.totalPages || Math.max(1, Math.ceil(pagination.total / pagination.size)))
}
